import axios from "axios";
import { stringify } from "querystring";

import { API_URL, API_CONTEXT_MORAL } from "settings";
import { getCurrentSessionData } from "utils/aws/cognito";

const http = axios.create({
  baseURL: API_URL,
});

let THIS_API_CONTEXT = API_CONTEXT_MORAL;

export const setApiContext = (newContext) => {
  THIS_API_CONTEXT = newContext;
};

http.interceptors.request.use((config) => {
  const { accessToken } = getCurrentSessionData();
  config.headers.Authorization = accessToken;

  if (THIS_API_CONTEXT) {
    config.headers.context = THIS_API_CONTEXT;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const { hash = "", pathname, search = "" } = window.location;
      const query = {};

      if (!pathname.startsWith("/auth/")) {
        query.redirect = Buffer.from(`${pathname}${search}${hash}`).toString(
          "base64",
        );
        window.location = `/auth/login?${stringify(query)}`;
        return;
      }
    }

    return Promise.reject(error);
  },
);

export default http;
